import {signal, WritableSignal} from '@angular/core';
import {ComponentMetadata} from '../../model/component-metadata.model';

export const formComponentSignal: WritableSignal<ComponentMetadata | undefined> = signal<ComponentMetadata | undefined>(undefined);
